import { useMemo, useCallback } from 'react';
import { useTheme } from '@mui/material';
import { extend } from 'colord';
import a11yPlugin from 'colord/plugins/a11y';
import { getThemeColorList, convertColor, getAccessibleTextColor } from './utils.js';

var useThemeColors = function () {
    extend([a11yPlugin]);
    var theme = useTheme();
    return {
        themeColorList: useMemo(function () { return getThemeColorList(theme); }, [theme]),
        convertColor: useCallback(function (color) { return convertColor(theme, color); }, [theme]),
        getAccessibleTextColor: useCallback(function (backgroundColor) { return getAccessibleTextColor(theme, backgroundColor); }, [theme])
    };
};

export { useThemeColors };
//# sourceMappingURL=hook.js.map
